import { FormLabel, GridLegacy, MenuItem, Select } from "@mui/material";
import React, { useMemo } from "react";
import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import { foodIcons, menuStylen, videoTypeList } from "../../../variables/app";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAppleAlt } from "@fortawesome/pro-regular-svg-icons/faAppleAlt";
import { faAppleCrate } from "@fortawesome/pro-regular-svg-icons/faAppleCrate";
import { faBacon } from "@fortawesome/pro-regular-svg-icons/faBacon";
import { faBeer } from "@fortawesome/pro-regular-svg-icons/faBeer";
import { faBlender } from "@fortawesome/pro-regular-svg-icons/faBlender";
import { faBone } from "@fortawesome/pro-regular-svg-icons/faBone";
import { faBreadLoaf } from "@fortawesome/pro-regular-svg-icons/faBreadLoaf";
import { faBreadSlice } from "@fortawesome/pro-regular-svg-icons/faBreadSlice";
import { faBurgerSoda } from "@fortawesome/pro-regular-svg-icons/faBurgerSoda";
import { faBurrito } from "@fortawesome/pro-regular-svg-icons/faBurrito";
import { faCandyCane } from "@fortawesome/pro-regular-svg-icons/faCandyCane";
import { faCandyCorn } from "@fortawesome/pro-regular-svg-icons/faCandyCorn";
import { faCarrot } from "@fortawesome/pro-regular-svg-icons/faCarrot";
import { faCheese } from "@fortawesome/pro-regular-svg-icons/faCheese";
import { faCheeseSwiss } from "@fortawesome/pro-regular-svg-icons/faCheeseSwiss";
import { faCheeseburger } from "@fortawesome/pro-regular-svg-icons/faCheeseburger";
import { faCloudMeatball } from "@fortawesome/pro-regular-svg-icons/faCloudMeatball";
import { faCocktail } from "@fortawesome/pro-regular-svg-icons/faCocktail";
import { faCoffee } from "@fortawesome/pro-regular-svg-icons/faCoffee";
import { faCoffeePot } from "@fortawesome/pro-regular-svg-icons/faCoffeePot";
import { faCoffeeTogo } from "@fortawesome/pro-regular-svg-icons/faCoffeeTogo";
import { faCookie } from "@fortawesome/pro-regular-svg-icons/faCookie";
import { faCookieBite } from "@fortawesome/pro-regular-svg-icons/faCookieBite";
import { faCorn } from "@fortawesome/pro-regular-svg-icons/faCorn";
import { faCroissant } from "@fortawesome/pro-regular-svg-icons/faCroissant";
import { faDrumstick } from "@fortawesome/pro-regular-svg-icons/faDrumstick";
import { faDrumstickBite } from "@fortawesome/pro-regular-svg-icons/faDrumstickBite";
import { faEgg } from "@fortawesome/pro-regular-svg-icons/faEgg";
import { faEggFried } from "@fortawesome/pro-regular-svg-icons/faEggFried";
import { faFish } from "@fortawesome/pro-regular-svg-icons/faFish";
import { faFishCooked } from "@fortawesome/pro-regular-svg-icons/faFishCooked";
import { faFlask } from "@fortawesome/pro-regular-svg-icons/faFlask";
import { faFlaskPotion } from "@fortawesome/pro-regular-svg-icons/faFlaskPotion";
import { faFrenchFries } from "@fortawesome/pro-regular-svg-icons/faFrenchFries";
import { faGingerbreadMan } from "@fortawesome/pro-regular-svg-icons/faGingerbreadMan";
import { faGlass } from "@fortawesome/pro-regular-svg-icons/faGlass";
import { faGlassChampagne } from "@fortawesome/pro-regular-svg-icons/faGlassChampagne";
import { faGlassCheers } from "@fortawesome/pro-regular-svg-icons/faGlassCheers";
import { faGlassCitrus } from "@fortawesome/pro-regular-svg-icons/faGlassCitrus";
import { faGlassMartini } from "@fortawesome/pro-regular-svg-icons/faGlassMartini";
import { faGlassMartiniAlt } from "@fortawesome/pro-regular-svg-icons/faGlassMartiniAlt";
import { faGlassWhiskey } from "@fortawesome/pro-regular-svg-icons/faGlassWhiskey";
import { faGlassWhiskeyRocks } from "@fortawesome/pro-regular-svg-icons/faGlassWhiskeyRocks";
import { faGlasses } from "@fortawesome/pro-regular-svg-icons/faGlasses";
import { faGlassesAlt } from "@fortawesome/pro-regular-svg-icons/faGlassesAlt";
import { faHamburger } from "@fortawesome/pro-regular-svg-icons/faHamburger";
import { faHatChef } from "@fortawesome/pro-regular-svg-icons/faHatChef";
import { faHotdog } from "@fortawesome/pro-regular-svg-icons/faHotdog";
import { faIceCream } from "@fortawesome/pro-regular-svg-icons/faIceCream";
import { faJug } from "@fortawesome/pro-regular-svg-icons/faJug";
import { faLemon } from "@fortawesome/pro-regular-svg-icons/faLemon";
import { faMeat } from "@fortawesome/pro-regular-svg-icons/faMeat";
import { faMug } from "@fortawesome/pro-regular-svg-icons/faMug";
import { faMugHot } from "@fortawesome/pro-regular-svg-icons/faMugHot";
import { faMugMarshmallows } from "@fortawesome/pro-regular-svg-icons/faMugMarshmallows";
import { faMugTea } from "@fortawesome/pro-regular-svg-icons/faMugTea";
import { faPepperHot } from "@fortawesome/pro-regular-svg-icons/faPepperHot";
import { faPie } from "@fortawesome/pro-regular-svg-icons/faPie";
import { faPizza } from "@fortawesome/pro-regular-svg-icons/faPizza";
import { faPizzaSlice } from "@fortawesome/pro-regular-svg-icons/faPizzaSlice";
import { faPopcorn } from "@fortawesome/pro-regular-svg-icons/faPopcorn";
import { faPumpkin } from "@fortawesome/pro-regular-svg-icons/faPumpkin";
import { faSalad } from "@fortawesome/pro-regular-svg-icons/faSalad";
import { faSandwich } from "@fortawesome/pro-regular-svg-icons/faSandwich";
import { faSausage } from "@fortawesome/pro-regular-svg-icons/faSausage";
import { faSeedling } from "@fortawesome/pro-regular-svg-icons/faSeedling";
import { faShishKebab } from "@fortawesome/pro-regular-svg-icons/faShishKebab";
import { faSoup } from "@fortawesome/pro-regular-svg-icons/faSoup";
import { faSteak } from "@fortawesome/pro-regular-svg-icons/faSteak";
import { faTurkey } from "@fortawesome/pro-regular-svg-icons/faTurkey";
import { faWheat } from "@fortawesome/pro-regular-svg-icons/faWheat";
import { faWineBottle } from "@fortawesome/pro-regular-svg-icons/faWineBottle";
import { faWineGlass } from "@fortawesome/pro-regular-svg-icons/faWineGlass";
import { faWineGlassAlt } from "@fortawesome/pro-regular-svg-icons/faWineGlassAlt";
import FormColorTC from "../../../components/Forms/FormColorTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import { useController, useWatch } from "react-hook-form";
import FormFile from "../../../components/Forms/FormFile";
import { ImageResolutionHint } from "../../../components/ImageHints/ImageResolutionHint";

function Branding() {
  let iconList = {
    faAppleAlt: faAppleAlt,
    faAppleCrate: faAppleCrate,
    faBacon: faBacon,
    faBeer: faBeer,
    faBlender: faBlender,
    faBone: faBone,
    faBreadLoaf: faBreadLoaf,
    faBreadSlice: faBreadSlice,
    faBurgerSoda: faBurgerSoda,
    faBurrito: faBurrito,
    faCandyCane: faCandyCane,
    faCandyCorn: faCandyCorn,
    faCarrot: faCarrot,
    faCheese: faCheese,
    faCheeseSwiss: faCheeseSwiss,
    faCheeseburger: faCheeseburger,
    faCloudMeatball: faCloudMeatball,
    faCocktail: faCocktail,
    faCoffee: faCoffee,
    faCoffeePot: faCoffeePot,
    faCoffeeTogo: faCoffeeTogo,
    faCookie: faCookie,
    faCookieBite: faCookieBite,
    faCorn: faCorn,
    faCroissant: faCroissant,
    faDrumstick: faDrumstick,
    faDrumstickBite: faDrumstickBite,
    faEgg: faEgg,
    faEggFried: faEggFried,
    faFish: faFish,
    faFishCooked: faFishCooked,
    faFlask: faFlask,
    faFlaskPotion: faFlaskPotion,
    faFrenchFries: faFrenchFries,
    faGingerbreadMan: faGingerbreadMan,
    faGlass: faGlass,
    faGlassChampagne: faGlassChampagne,
    faGlassCheers: faGlassCheers,
    faGlassCitrus: faGlassCitrus,
    faGlassMartini: faGlassMartini,
    faGlassMartiniAlt: faGlassMartiniAlt,
    faGlassWhiskey: faGlassWhiskey,
    faGlassWhiskeyRocks: faGlassWhiskeyRocks,
    faGlasses: faGlasses,
    faGlassesAlt: faGlassesAlt,
    faHamburger: faHamburger,
    faHatChef: faHatChef,
    faHotdog: faHotdog,
    faIceCream: faIceCream,
    faJug: faJug,
    faLemon: faLemon,
    faMeat: faMeat,
    faMug: faMug,
    faMugHot: faMugHot,
    faMugMarshmallows: faMugMarshmallows,
    faMugTea: faMugTea,
    faPepperHot: faPepperHot,
    faPie: faPie,
    faPizza: faPizza,
    faPizzaSlice: faPizzaSlice,
    faPopcorn: faPopcorn,
    faPumpkin: faPumpkin,
    faSalad: faSalad,
    faSandwich: faSandwich,
    faSausage: faSausage,
    faSeedling: faSeedling,
    faShishKebab: faShishKebab,
    faSoup: faSoup,
    faSteak: faSteak,
    faTurkey: faTurkey,
    faWheat: faWheat,
    faWineBottle: faWineBottle,
    faWineGlass: faWineGlass,
    faWineGlassAlt: faWineGlassAlt,
  };

  const foodIconsOptions = useMemo(
    () =>
      foodIcons.map((prop, key) => {
        let label = prop.label;

        if (prop.transKey !== undefined) {
          label = getTranslation("global" + "." + prop.transKey, prop.label);
        }

        return (
          <MenuItem key={key} value={prop.value}>
            {prop.value !== "" ? <FontAwesomeIcon icon={iconList[prop.value]} size={"2x"} /> : ""} {label}
          </MenuItem>
        );
      }),
    []
  );

  const videoTypeListOptions = useMemo(() => convertArrayToSelectOptions(videoTypeList, null), []);
  const menuStylenOptions = useMemo(() => convertArrayToSelectOptions(menuStylen, null), []);

  const {
    field: { onChange, value },
  } = useController({ name: "videoType", defaultValue: "" });

  const appTarget = useWatch({ name: "vestiging.appTarget" });
  const salesarea_type = useWatch({ name: "vestiging.salesarea_type" });

  return (
    <Card style={{ maxWidth: 1200 }}>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={3}>
          <GridLegacy container item md={6} spacing={1} xs={12}>
            <GridLegacy item sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tDefault={"Afbeelding"} tKey={"menukaarten.form.afbeelding.label.afbeelding"} />
              </FormLabel>
              {salesarea_type === "KIOSK" ? <ImageResolutionHint res={"300x300"} /> : null}
            </GridLegacy>
            <GridLegacy item sm={8} xs={12}>
              <FormFile canCrop={true} name={"imgid"} nullable={true} type={"image"} />
            </GridLegacy>

            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tKey={"Banner"} />
              </h3>
            </GridLegacy>
            <GridLegacy item sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Banner type"} />
              </FormLabel>
              {salesarea_type === "KIOSK" ? <ImageResolutionHint res={"1080x300"} /> : null}
              {salesarea_type === "QR" ? <ImageResolutionHint res={"390x100"} /> : null}
              {salesarea_type === "PICKUP_DELIVERY" ? <ImageResolutionHint res={"2336x578"} /> : null}
            </GridLegacy>
            <GridLegacy item sm={8} xs={12}>
              <Select
                onChange={onChange}
                style={{ width: "100%", backgroundColor: "rgba(100, 100, 100, 0.05)" }}
                value={value}
              >
                {videoTypeListOptions}
              </Select>
            </GridLegacy>

            {appTarget == "app_lite.js" ? (
              <FormSelectTC
                name={"headerDisplayMode"}
                options={[
                  <MenuItem value={"contain"}>
                    <TranslationWrapper tDefault={"Contain"} tKey={"menukaarten.form.algemeen.label.contain"} />
                  </MenuItem>,
                  <MenuItem value={"cover"}>
                    <TranslationWrapper tDefault={"Cover"} tKey={"menukaarten.form.algemeen.label.cover"} />
                  </MenuItem>,
                ]}
                tDefault={"Header display mode"}
                tKey={"menukaarten.form.algemeen.label.headerDisplayMode"}
              />
            ) : null}

            <GridLegacy item sm={4} xs={12} />
            <GridLegacy item sm={8} xs={12}>
              {value == 0 || value == null ? (
                <FormFile canCrop={true} name={"imgidbanner"} nullable={true} type={"image"} />
              ) : null}
            </GridLegacy>

            {value != 0 ? (
              <FormTextTC
                name={"videoSource"}
                tDefault={"Video source"}
                tKey={"menukaarten.form.algemeen.label.videoSource"}
              />
            ) : null}
          </GridLegacy>

          <GridLegacy container item md={6} spacing={1} style={{ alignContent: "flex-start" }} xs={12}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tKey={"Extra"} />
              </h3>
            </GridLegacy>

            <FormSelectTC
              defaultValue={"faAppleAlt"}
              name={"iconName"}
              options={foodIconsOptions}
              tDefault={"Icoon"}
              tKey={"menukaarten.form.algemeen.label.icoon"}
            />

            <FormColorTC
              name={"fontColor"}
              nullable={true}
              tDefault={"Fontcolor"}
              tKey={"menukaarten.form.algemeen.label.fontColor"}
            />

            <FormColorTC
              name={"bgColor"}
              nullable={true}
              tDefault={"Background colour"}
              tKey={"menukaarten.form.algemeen.label.bgColor"}
            />

            <FormTextTC
              name={"bgClass"}
              tDefault={"Background class"}
              tKey={"menukaarten.form.algemeen.label.bgClass"}
            />

            <FormSwitchTC
              name={"kioskShowImage"}
              tDefault={"Kiosk show image"}
              tKey={"menukaarten.form.algemeen.label.kioskShowImage"}
            />

            <FormSwitchTC
              defaultValue={true}
              name={"settings.kiosk.showName"}
              tDefault={"Kiosk show name"}
              tKey={"settings.kiosk.showName"}
            />

            <FormSwitchTC
              defaultValue={false}
              name={"settings.kiosk.stickyBanner"}
              tDefault={"Kiosk have a sticky banner"}
              tKey={"settings.kiosk.stickyBanner"}
            />

            <FormSelectTC
              defaultValue={0}
              name={"menuStyle"}
              options={menuStylenOptions}
              tDefault={"Overwrite style"}
              tKey={"menukaarten.form.algemeen.label.menuSTyle"}
            />

            <FormControlledInputTC
              name={"columnCount"}
              rules={{
                min: { value: 1, message: <TranslationWrapper tKey={"The minimal value is 1!"} /> },
                pattern: {
                  value: /^[0-9]*$/,
                  message: <TranslationWrapper tKey={"Only whole numbers are allowed!"} />,
                },
              }}
              tKey={"menukaarten.form.algemeen.label.columnCount"}
              type={"number"}
            />

            <SettingsColumns />
          </GridLegacy>
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

function SettingsColumns() {
  return (
    <>
      <FormControlledInputTC
        name={"settings.columnMinWidth.qr"}
        nullable
        rules={{
          min: {
            value: 150,
            message: <TranslationWrapper tKey={"Minimum value is 150."} />,
          },
        }}
        tDefault={"Min width (px) of article in QR (V5 only)"}
        tKey={"menukaarten.form.algemeen.label.settings.columnMinWidth.qr"}
        type={"number"}
      />
      <FormControlledInputTC
        name={"settings.columnCount.kiosk"}
        nullable
        tDefault={"Number of columns in kiosk (V5 only)"}
        tKey={"menukaarten.form.algemeen.label.settings.columnCount.kiosk"}
        type={"number"}
      />
      <FormControlledInputTC
        name={"settings.rowCount.kiosk"}
        nullable
        tDefault={"Number of items shown in kiosk (V5 only)"}
        tKey={"menukaarten.form.algemeen.label.settings.rowCount.kiosk"}
        type={"number"}
      />
      <FormControlledInputTC
        name={"settings.rowCount.qr"}
        nullable
        tDefault={"Number of items shown in qr (V5 only)"}
        tKey={"menukaarten.form.algemeen.label.settings.rowCount.qr"}
        type={"number"}
      />
      <FormSelectTC
        name={"settings.orientation"}
        options={[
          <MenuItem key={"Default"} value={"row"}>
            Horizontal
          </MenuItem>,
          <MenuItem key={"column"} value={"column"}>
            Vertical
          </MenuItem>,
        ]}
        tDefault={"Orientation of product view"}
        tKey={"menukaarten.form.algemeen.label.settings.orientation"}
        value={"row"}
      />
    </>
  );
}

export default Branding;
